import {ImageService} from '../../shared/services/advtech/image/image.service';

/**
 * Class used to transform the list api response to usable entities
 * @class
 */
export class ListEntity {

  /**
   * List type
   * @type {string}
   */
  type: string;

  /**
   * @constructor
   * @param {{image: { url: string }, status: string, author: {firstName: string, lastName: string, username: string }, title: string}} obj the list object form the api
   * @param {ImageService} imageService Instance of the image service class
   */
  constructor(obj: any, public imageService: ImageService) {
    this.type = obj.typeLabel;
  }
}


// WEBPACK FOOTER //
// ./src/app/list/entities/list.entity.ts